document.addEventListener('DOMContentLoaded', () => {
  // collection - header-filter 숫자 bold 처리
    const el = document.getElementById('ProductCount_header');

    if (el) {
      const boldNumber = () => {
        const text = el.textContent;
        el.innerHTML = text.replace(/\d+/g, '<strong>$&</strong>');
      };

      const observer = new MutationObserver(() => {
        observer.disconnect();
        boldNumber();
        observer.observe(el, {
          childList: true,
          characterData: true,
          subtree: true,
        });
      });

      boldNumber();

      observer.observe(el, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    setTimeout(() => {
    const el = document.getElementById('ProductCount_header');

    if (el) {
      el.innerHTML = el.textContent.replace(/\d+/g, '<strong>$&</strong>');
    }
  }, 500);

  // pdp - 섹션 백그라운드 리벌스 처리
    const sections = [...document.querySelectorAll('.theme-template-product section.shopify-section')]
      .filter(section =>
        section.offsetHeight > 0 &&
        !section.classList.contains('section-apps') &&
        !section.classList.contains('section-recently-viewed')
      );

    sections.forEach((section, index) => {
      section.classList.add(index % 2 === 0 ? 'pdp-bg-odd' : 'pdp-bg-even');
    });

  // pdp - 하단바 페이드아웃 처리
    const stickyBar = document.querySelector('.sticky_add_to_cart');
    const footer = document.querySelector('#section-footer, footer');

    if (!stickyBar || !footer) return;

    function hideStickyBar() {
      stickyBar.classList.add('is-footer-overlap');
    }

    function showStickyBar() {
      stickyBar.classList.remove('is-footer-overlap');
    }

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          hideStickyBar();
        } else {
          showStickyBar();
        }
      });
    }, {
      root: null,
      threshold: 0
    });

    observer.observe(footer);

  // newsletter & contact - 라벨 desabled selected 처리
    function setSelectPlaceholder() {
      document.querySelectorAll('.newsletter__gender, .newsletter__age, .newsletter__birth-year, .newsletter__birth-month, .newsletter__birth-day, .newsletter__visit, .contact__select')
        .forEach(function (wrap) {
          const label = wrap.querySelector('label');
          const select = wrap.querySelector('select');
          if (!label || !select) return;

          const firstOption = select.querySelector('option:first-child');
          if (!firstOption) return;

          firstOption.textContent = label.textContent.trim();
          firstOption.value = '';
          firstOption.disabled = true;
          firstOption.selected = true;

          select.value = '';
        });
    }

      setSelectPlaceholder();

      setTimeout(setSelectPlaceholder, 500);
      setTimeout(setSelectPlaceholder, 1500);
      setTimeout(setSelectPlaceholder, 3000);

      window.addEventListener('load', setSelectPlaceholder);

  // newsletter & contact - 라벨 placeholder 처리
      function setInputLabelState() {
      document.querySelectorAll(
        '.globo-form-control[data-type="name"], .globo-form-control[data-type="email"], .globo-form-control[data-type="textarea"]'
      ).forEach(function (wrap) {
        const field = wrap.querySelector('input, textarea');
        if (!field) return;

        function toggleFilled() {
          wrap.classList.toggle('has-value', field.value.trim() !== '');
        }

        field.addEventListener('input', toggleFilled);
        field.addEventListener('change', toggleFilled);

        toggleFilled();
      });
    }

    setInputLabelState();
    setTimeout(setInputLabelState, 500);
    setTimeout(setInputLabelState, 1500);
    setTimeout(setInputLabelState, 3000);
    window.addEventListener('load', setInputLabelState);

  // contact - 파일 첨부 최대 5개 제한
  function limitContactUploadFiles() {
    const wraps = document.querySelectorAll('.contact__upload');

    wraps.forEach(function (wrap) {
      if (wrap.dataset.maxFileLimitApplied === 'true') return;
      wrap.dataset.maxFileLimitApplied = 'true';

      function getUploadedCount() {
        return wrap.querySelectorAll('.gfb__dropzone--preview--item').length;
      }

      const input = wrap.querySelector('input[type="file"]');
      const uploadButton = wrap.querySelector('.gfb__dropzone--placeholder, .gfb__dropzone--placeholder--button');

      // 5개 찼을 때 업로드 버튼만 막기
      if (uploadButton) {
        uploadButton.addEventListener('click', function (e) {
          if (getUploadedCount() >= 5) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            alert('画像は最大5枚まで添付できます。');
            return false;
          }
        }, true);
      }

      // 한 번에 여러 장 선택할 때 5개 초과 방지
      if (input) {
        input.addEventListener('change', function (e) {
          const currentCount = getUploadedCount();
          const selectedCount = input.files ? input.files.length : 0;

          if (currentCount + selectedCount > 5) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            alert('画像は最大5枚まで添付できます。');
            input.value = '';
            return false;
          }
        }, true);
      }
    });
  }

  limitContactUploadFiles();
  setTimeout(limitContactUploadFiles, 500);
  setTimeout(limitContactUploadFiles, 1500);
  setTimeout(limitContactUploadFiles, 3000);
  window.addEventListener('load', limitContactUploadFiles);

});

// 채널톡 플로팅 위젯 카트 모달 / PDP 하단바 모달 열렸을 때 숨기기
document.addEventListener('DOMContentLoaded', function () {
  function toggleFloatingWidgets() {
    const isStickyOpen = !!document.querySelector('.sticky_add_to_cart.is-open');
    const isCartDrawerOpen = !!document.querySelector('#update-cart.is-open');
    const shouldHideFloatingWidgets = isStickyOpen || isCartDrawerOpen;

    const targets = document.querySelectorAll(
      '.scroll_top, .stamped-launcher-button, .jwZDjY, [class*="LauncherButton"], [class*="launcherButton"], #ch-plugin, iframe[src*="channel"], iframe[src*="channel.io"]'
    );

    targets.forEach(function (target) {
      target.style.setProperty('opacity', shouldHideFloatingWidgets ? '0' : '', 'important');
      target.style.setProperty('visibility', shouldHideFloatingWidgets ? 'hidden' : '', 'important');
      target.style.setProperty('pointer-events', shouldHideFloatingWidgets ? 'none' : '', 'important');
    });
  }

  toggleFloatingWidgets();

  document.addEventListener('click', function () {
    setTimeout(toggleFloatingWidgets, 50);
    setTimeout(toggleFloatingWidgets, 300);
  });

  const observer = new MutationObserver(toggleFloatingWidgets);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  });
});

//임시(header 드롭다운 메뉴 작업시 사용)
// document.addEventListener('DOMContentLoaded', () => {
//   const interval = setInterval(() => {
//     const store = window.Alpine?.store('xHeaderMenu');
//     if (store) {
//       store.show = 4;
//     }
//   }, 100);
//   window._keepMenuOpen = interval;
// });